// extracted by mini-css-extract-plugin
module.exports = {"border":"Contact_border__1KICu","contactForm":"Contact_contactForm__11Tuq","contactFormLabel":"Contact_contactFormLabel__p2wjt","contactFormText":"Contact_contactFormText__3ZvaD"};